import React from 'react';
import { compose } from 'redux';
import DashboardTemplate from 'components/templates/Dashboard';
import HeaderContainer from 'containers/HeaderContainer';
import PageQuery from 'hoc/PageQuery';
import PageView from 'hoc/PageView';
import PageTitle from 'hoc/PageTitle';
import ProtectedRoute, { DashboardsProtections } from 'hoc/ProtectedRoute';
import PageTheme from 'hoc/PageTheme';

import DetermineLayerContainer from 'containers/dashboards/DetermineLayerContainer';
import LayerThreeSummaryContainer from 'containers/dashboards/LayerThreeSummaryContainer';
import LayerTwoSummaryContainer from 'containers/dashboards/LayerTwoSummaryContainer';

import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/DashboardSideBarObjects';
import showGGBrandingTheme from 'helpers/showGGBrandingTheme';
import { getQueryParamDefForObjectiveSwitcher } from 'helpers/objectiveSettings';
import { getQueryParamDefForRange } from 'helpers/range';

const SummaryDashboard = props => (
    <DashboardTemplate
        header={<HeaderContainer />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer entityId={parseInt(props.match.params.entityId, 10)} />}>
        <DetermineLayerContainer
            layerTwo={LayerTwoSummaryContainer}
            layerThree={LayerThreeSummaryContainer}
            {...props} />
    </DashboardTemplate>
);

export default compose(
    ProtectedRoute(DashboardsProtections),
    PageTitle({ pageTitle: 'Summary' }),
    PageView({ page: 'Viewed Entity Summary', trackEntity: true }),
    PageTheme({ themeDefaults: { 'whitelabel.showGGBranding': showGGBrandingTheme } }),
    PageQuery({
        params: {
            ...getQueryParamDefForRange(),
            ...getQueryParamDefForObjectiveSwitcher()
        },
        initialTruth: 'location',
    }),
)(SummaryDashboard);



// WEBPACK FOOTER //
// ./src/components/pages/dashboards/Summary.js